import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    /* Light theme variables */
    --bg-primary: #ffffff;
    --bg-secondary: #f1f5f9;
    --text-primary: #0f172a;
    --text-secondary: #475569;
    --accent-color: #0ea5e9;
    --accent-hover: #0284c7;
    --card-bg: rgba(255, 255, 255, 0.98);
    --card-border: rgba(14, 165, 233, 0.15);
    --card-shadow: rgba(0, 0, 0, 0.05);
  }

  [data-theme='dark'] {
    --bg-primary: #0a0f1c;
    --bg-secondary: #1a1f2c;
    --text-primary: #e6f1ff;
    --text-secondary: #8892b0;
    --accent-color: #64ffda;
    --accent-hover: #4cd8b2;
    --card-bg: rgba(10, 15, 28, 0.7);
    --card-border: rgba(100, 255, 218, 0.2);
    --card-shadow: rgba(0, 0, 0, 0.3);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: var(--bg-primary);
    color: var(--text-primary);
    line-height: 1.6;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 1rem;
    color: var(--text-primary);
  }

  a {
    color: var(--accent-color);
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: var(--accent-hover);
    }
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
    font-size: inherit;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--bg-secondary);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--accent-color);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--accent-hover);
  }

  /* Selection */
  ::selection {
    background: var(--accent-color);
    color: var(--bg-primary);
  }

  /* Focus styles */
  :focus {
    outline: 2px solid var(--accent-color);
    outline-offset: 2px;
  }

  /* Loading animation */
  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }

  .loading {
    background: linear-gradient(
      90deg,
      var(--bg-secondary) 25%,
      var(--bg-primary) 50%,
      var(--bg-secondary) 75%
    );
    background-size: 1000px 100%;
    animation: shimmer 2s infinite linear;
  }
`; 